import { ThemeType } from '@app/api/models/Theme';
import styled from 'lib/styled';
import React from 'react';
import { FC } from 'react';
import { colors } from '../../Shared/Style/colors';
import { ReactComponent as Icon } from '../move-layer-down-outline-16.svg';

const ThemedDownload = styled(Icon)(({ theme }: { theme: ThemeType }) => {
    return {
        height: '24px',
        width: '24px',
        '& g': {
            stroke: theme?.colors?.icons || colors.icons,
        },
        '& path': {
            strokeWidth: '1px',
        },
    };
});
const Download: FC = ({ ...rest }) => {
    return <ThemedDownload {...rest} />;
};

export default Download;
